import React  from 'react'
import { Dialog, DialogContent } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from './OrderRatingDialog.module.css'
import DialogContentText from '@material-ui/core/DialogContentText'

const useStyles = makeStyles({
  paper: {
    padding: '15px 30px 32px'
  }
})

export function OrderRatingsDialog ({
  onClose,
  isOpen,
  children
}) {
  const classes = useStyles()

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth={'md'}
      fullWidth
    >
      <DialogContent className={classes.paper}>
        <DialogContentText className={styles.contentContainer}>
          {children}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  )
}
